import {useResponsivePropValue} from '../../hooks/useResponsivePropValue';
import {Integer} from '../../types/Integer';
import {ValueByDevice} from '../../types/ValueByDevice';
import {getSize} from '../../utils/getSize';

export interface SpaceProps {
  vertical?: Integer | ValueByDevice<Integer> | null;
  horizontal?: Integer | ValueByDevice<Integer> | null;
  fillAvailable?: boolean;
  max?: Integer;
}

export function Space(props: SpaceProps) {
  const max = props.max ? getSize(props.max) : 'initial';
  const horizontal = useResponsivePropValue(props.horizontal);
  const vertical = useResponsivePropValue(props.vertical);

  return (
    <div
      aria-hidden="true"
      className="pointer-events-none basis-auto select-none [outline:none]"
      style={{
        width: getSize(horizontal ?? 0),
        height: getSize(vertical ?? 0),
        maxWidth: max,
        maxHeight: max,
        flexGrow: props.fillAvailable ? 1 : 0,
        flexShrink: props.fillAvailable ? 1 : 0,
      }}
    />
  );
}
